var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCta = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.94 10 24 5.954m0 0L21.001 2M24 5.954l-23 .1",
  stroke: "currentcolor",
  strokeWidth: 1.6,
  strokeLinecap: "square"
})));

export default SvgIconCta;